// extracted by mini-css-extract-plugin
module.exports = {"title":"dece2e673c--title--3pcI7","load-more-button":"dece2e673c--load-more-button--20FCt"};